module.exports = __webpack_public_path__ + "img/time-line.6eaffe26.svg";